import {useEffect, useState} from 'react';
import {AutoComplete, Row, Col} from 'antd';
import {getAllProducts, getProductCategory} from "../../api/Api";
import {CategoryType} from "../../api/Constants";


export const ProductSearchWidget = ({onApiFail, refresh, onSelect, type="packaged", props}) => {
    const [products, setProducts] = useState([]);
    const [options, setOptions] = useState([])
    const [value, setValue] = useState(undefined);

    useEffect(() => {
        let promise;
        if (type === "packaged") {
            promise = getProductCategory(CategoryType.Packaged);
        } else if (type === "wholesale") {
            promise = getProductCategory(CategoryType.Wholesale);
        } else {
            promise = getAllProducts();
        }

        promise.then((x) => {
            const tableData = x.map((val, index) => {
                return {...val, key: val.id}
            });
            setProducts(tableData);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
        clearForm();
    }, [type, refresh, onApiFail]);

    const clearForm = () => {
        setValue(undefined);
    }

    const onChange = (data) => {
        setValue(data);
    }

    const onSearch = (text) => {
        const newOptions = products.filter(item => {
            const ltext = text.toLowerCase();
            return (item.name.toLowerCase().includes(ltext));// || item.sku.toLowerCase().includes(ltext));
        }).map(val => {
            return {
                value: `${val.name}`, // - ${val.sku}`,
                item: val,
                key: val.key
            }
        });
        setOptions(newOptions)
    }

    const select = (val, option) => {
        if (onSelect) {
            onSelect(option.item);
        }
    }

    const autoCompleteStyle = {
        width: 350
    }

    const rowStyle = {
        marginTop: "5px",
        marginBottom: "5px"
    }

    return <Row style={rowStyle}>
        <Col span={8}>
            <AutoComplete placeholder={`Products`} style={autoCompleteStyle} options={options} onSelect={select} onSearch={onSearch} value={value} onChange={onChange} />
        </Col>
    </Row>
}